export enum USER_SAVED_ITEMS {
    /**
     * @value Clear saved items
     * @description Message displayed in the button to empty the user's saved items.
     * The message is also displayed as the the confirmation dialog title.
     */
    CLEAR_ITEMS = 'USER_SAVED_ITEMS.CLEAR_ITEMS',
    /**
     * @value All saved items will be removed.
     * @description Message shown to warn the user that all saved items will be removed.
     */
    ITEMS_WILL_BE_REMOVED = 'USER_SAVED_ITEMS.ITEMS_WILL_BE_REMOVED',
    /**
     * @value Your saved items are private and cannot be seen by other people.
     * @description Message to explain that the user's saved items are hidden from other users.
     */
    PRIVATE_FROM_OTHERS = 'USER_SAVED_ITEMS.PRIVATE_FROM_OTHERS',
    /**
     * @value Saved
     * @description Text to define the "saved items" features.
     * Used in user menu / page title etc...
     */
    SAVED_ITEMS = 'USER_SAVED_ITEMS.SAVED_ITEMS',
    /**
     * @value Save functionality is unavailable. Try to reload or come back later.
     * @description Error message that shows up when trying to display a Save button.
     */
    SAVE_UNAVAILABLE = 'USER_SAVED_ITEMS.SAVE_UNAVAILABLE',
}
